import {TagModel} from '@domain-group/realhub-backend-api-types'
const state = {
  global: false,
  hidden: false,
  id: undefined,
  image_file: '',
  image_file_name: '',
  owner_id: undefined,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'owner_id', validation: (ownerId: number, { global }: TagModel) => global || !!ownerId },
]

export default state
